import { render } from "./cjabnormalCall.vue?vue&type=template&id=125cf24a&scoped=true"
import script from "./cjabnormalCall.vue?vue&type=script&lang=js"
export * from "./cjabnormalCall.vue?vue&type=script&lang=js"

import "./cjabnormalCall.vue?vue&type=style&index=0&id=125cf24a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-125cf24a"

export default script